import React from "react";

interface HeartFilledIconProps
  extends Omit<React.SVGProps<SVGSVGElement>, "width" | "height" | "fill"> {
  width?: number | string;
  height?: number | string;
  fill?: string;
}

const HeartFilledIcon: React.FC<HeartFilledIconProps> = ({
  width = 23,
  height = 20,
  fill = "#FFE9D9",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 23 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.4524 19.1996C12.3781 19.1996 12.3037 19.1774 12.2294 19.1404C11.8281 18.9033 2.41211 13.1996 2.41211 7.07368C2.41954 4.05887 4.93147 1.59961 8.01564 1.59961C9.76209 1.59961 11.4045 2.41442 12.4598 3.76257C13.5077 2.41442 15.1575 1.59961 16.904 1.59961C19.9956 1.59961 22.5001 4.05887 22.5001 7.07368C22.5001 13.1996 13.0915 18.8959 12.6828 19.1404C12.6159 19.1848 12.5416 19.1996 12.4598 19.1996H12.4524Z"
      fill={fill}
    />
    <path
      d="M10.8575 2.76333L11.2548 3.27827L11.6503 2.76198C12.7301 1.35248 14.4317 0.5 16.2309 0.5C19.4204 0.5 21.9985 3.07375 21.9985 6.22054C21.9985 7.83515 21.3865 9.45269 20.421 10.9956C19.4566 12.5367 18.1578 13.974 16.8306 15.2181C14.2071 17.6773 11.5248 19.3341 11.2525 19.4999C11.2489 19.4988 11.2428 19.4966 11.234 19.4927C10.918 19.3011 8.26629 17.6541 5.6711 15.2213C4.34336 13.9766 3.04369 12.5385 2.07865 10.9967C1.11261 9.45331 0.500152 7.83548 0.5 6.22114C0.507981 3.07387 3.09484 0.5 6.27595 0.5C8.0741 0.5 9.76849 1.35174 10.8575 2.76333Z"
      stroke="#1A1A1A"
    />
    <path
      d="M10.8575 2.76333L11.2548 3.27827L11.6503 2.76198C12.7301 1.35248 14.4317 0.5 16.2309 0.5C19.4204 0.5 21.9985 3.07375 21.9985 6.22054C21.9985 7.83515 21.3865 9.45269 20.421 10.9956C19.4566 12.5367 18.1578 13.974 16.8306 15.2181C14.2071 17.6773 11.5248 19.3341 11.2525 19.4999C11.2489 19.4988 11.2428 19.4966 11.234 19.4927C10.918 19.3011 8.26629 17.6541 5.6711 15.2213C4.34336 13.9766 3.04369 12.5385 2.07865 10.9967C1.11261 9.45331 0.500152 7.83548 0.5 6.22114C0.507981 3.07387 3.09484 0.5 6.27595 0.5C8.0741 0.5 9.76849 1.35174 10.8575 2.76333Z"
      stroke="black"
      strokeOpacity="0.2"
    />
    <path
      d="M10.8575 2.76333L11.2548 3.27827L11.6503 2.76198C12.7301 1.35248 14.4317 0.5 16.2309 0.5C19.4204 0.5 21.9985 3.07375 21.9985 6.22054C21.9985 7.83515 21.3865 9.45269 20.421 10.9956C19.4566 12.5367 18.1578 13.974 16.8306 15.2181C14.2071 17.6773 11.5248 19.3341 11.2525 19.4999C11.2489 19.4988 11.2428 19.4966 11.234 19.4927C10.918 19.3011 8.26629 17.6541 5.6711 15.2213C4.34336 13.9766 3.04369 12.5385 2.07865 10.9967C1.11261 9.45331 0.500152 7.83548 0.5 6.22114C0.507981 3.07387 3.09484 0.5 6.27595 0.5C8.0741 0.5 9.76849 1.35174 10.8575 2.76333Z"
      stroke="black"
      strokeOpacity="0.2"
    />
    <path
      d="M10.8575 2.76333L11.2548 3.27827L11.6503 2.76198C12.7301 1.35248 14.4317 0.5 16.2309 0.5C19.4204 0.5 21.9985 3.07375 21.9985 6.22054C21.9985 7.83515 21.3865 9.45269 20.421 10.9956C19.4566 12.5367 18.1578 13.974 16.8306 15.2181C14.2071 17.6773 11.5248 19.3341 11.2525 19.4999C11.2489 19.4988 11.2428 19.4966 11.234 19.4927C10.918 19.3011 8.26629 17.6541 5.6711 15.2213C4.34336 13.9766 3.04369 12.5385 2.07865 10.9967C1.11261 9.45331 0.500152 7.83548 0.5 6.22114C0.507981 3.07387 3.09484 0.5 6.27595 0.5C8.0741 0.5 9.76849 1.35174 10.8575 2.76333Z"
      stroke="black"
      strokeOpacity="0.2"
    />
  </svg>
);

export default HeartFilledIcon;
